<div class="flex flex-col justify-center text-center bg-white rounded-xl p-2">
  <p class="mt-0 font-theme-source text-sm pl-2 pr-2 text-left">
    <span class="font-bold mr-1">Informations</span> ·
    <span class="mr-1 ml-1 underline">Recherche</span> ·
    <span class="ml-1">Finalisation</span>
  </p>

  <div class="mt-5 mb-5 w-full md:w-[576px] ml-auto mr-auto">
    <div class="flex flex-col w-full justify-center items-center mt-5 text-left pl-4 pr-4 " [formGroup]="subscriptionSearchActions.searchForm">
      <app-form-dropdown class="w-full" [tabIndex]="1" label="" [formGroup]="subscriptionSearchActions.searchForm" name="age"
                         [placeholder]="referralCode() ? 'Sélectionne son âge dans la liste' : 'Sélectionne ton âge dans la liste'"
                         [choices]="subscriptionSearchActions.ageChoices" [big]="true" (onChange)="subscriptionSearchActions.updateAges(leadResources.currentLead.value()?.sex, 'age')"></app-form-dropdown>

      <div *ngIf="!subscriptionSearchActions.searchForm.controls.age.value && leadResources.currentLead.value()?.sex=='M'"
         class="mt-4 font-theme-source text-theme-black bg-theme-yellow p-2 text-sm font-normal text-center rounded-lg">
        <p>Pour garantir des rencontres de qualité, <span class="font-bold">merci d'indiquer l'âge exact</span>. L'honnêteté, c'est le secret des beaux matchs !</p>
      </div>

      <app-age-range-slider *ngIf="subscriptionSearchActions.searchForm.controls.age.value > 0"
                            [class.mt-15]="leadResources.currentLead.value()?.sex=='M'"
                            [class.mt-5]="leadResources.currentLead.value()?.sex!='M'"
                            class=" w-full"
                            [label]="referralCode() ? 'Sa recherche' : 'Ma recherche'"
                            [formGroup]="subscriptionSearchActions.searchForm"
                            [choices]="subscriptionSearchActions.ageRangeChoices()"
                            (onChangeMin)="subscriptionSearchActions.updateAges(leadResources.currentLead.value()?.sex,'min')"
                            (onChangeMax)="subscriptionSearchActions.updateAges(leadResources.currentLead.value()?.sex,'max')"></app-age-range-slider>

      <p class="mt-3 font-theme-source text-theme-black text-xs text-center font-normal" *ngIf="!subscriptionSearchActions.errorMessage && subscriptionSearchActions.searchForm.controls.age.value">
        Les choix possibles sont automatiquement ajustés pour empêcher les écarts d'âge inappropriés et permettre d'obtenir un maximum de coups de coeur réciproques.
      </p>

      <div *ngIf="subscriptionSearchActions.searchForm.controls.age.value > 0 && topic.value()?.searchOptions?.length > 0" class="mt-8 w-full ml-auto mr-auto font-theme-source">
        <p class="mb-2" *ngFor="let searchOption of topic.value()?.searchOptions">
          <app-form-checkbox [black]="true" [formGroup]="topicSearchForm" name="options" label="{{searchOption.label}}" [big]="true" [multiChoices]="true" [multiValues]="true"
                             [choiceValue]="searchOption.code" (onChangeOption)="changeTopicSearchOption($event)"></app-form-checkbox>
        </p>
      </div>

      <div *ngIf="subscriptionSearchActions.searchForm.controls.age.value > 0" class="flex flex-col w-full font-theme-source mt-10">
        <div class="flex flex-col w-full mb-5 ">
          <p class="w-full text-left font-bold text-2xl text-theme-black" [ngSwitch]="referralCode()">
            <span *ngSwitchCase="true">Son offre</span>
            <span *ngSwitchCase="false">Mon offre</span>
          </p>
          <div class="w-full flex flex-col mt-5 font-theme-source text-theme-black bg-theme-green p-2 text-sm text-left font-normal" >
            <p>Les coups de coeur sont les <span class="font-bold">numéros de téléphone de célibataires</span> que tu peux demander après la soirée.</p>
            <p class="mt-1">Billet <span class="font-bold">annulable avec remboursement </span> jusqu'à J-14.</p>
          </div>
        </div>
        <div class="flex flex-col w-full">
          <p class="mb-8 2xs:mb-2" *ngFor="let offer of offers">
            <app-form-checkbox [black]="true" [formGroup]="subscriptionSearchActions.searchForm" name="offer"
                               [label]="offer.richFromLabel(isComplete)"
                               [choiceValue]="offer.code" (onChangeOption)="changeOffer($event)" [multiChoices]="true" [big]="true"></app-form-checkbox>
          </p>
        </div>
      </div>

      <p *ngIf="subscriptionSearchActions.errorMessage" class="w-full bg-theme-red p-2 rounded-xl font-bold text-center font-theme-source text-white">{{subscriptionSearchActions.errorMessage}}</p>
    </div>
  </div>
</div>

<app-sub-navbar-v2 [isValid]="subscriptionSearchActions.searchForm.valid" (onNext)="next()" class="mt-5"></app-sub-navbar-v2>
